interface Topic {
  label: string;
  heat: string;
}

const topics: Topic[] = [
  { label: '韩漫推荐', heat: '98.6万' },
  { label: '日漫连载', heat: '87.3万' },
  { label: '国漫崛起', heat: '76.8万' },
  { label: '恋爱漫画', heat: '92.1万' },
  { label: '奇幻冒险', heat: '65.4万' },
  { label: '都市剧情', heat: '58.2万' },
  { label: '悬疑推理', heat: '43.7万' },
  { label: '热血格斗', heat: '71.5万' },
  { label: '校园青春', heat: '55.9万' },
  { label: '霸总题材', heat: '89.0万' },
  { label: '穿越重生', heat: '82.6万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-500">大家都在讨论的漫画话题，看看有没有你感兴趣的</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 border border-background-200/60 hover:border-primary-300/60 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800">{topic.label}</span>
              <span className="text-xs text-accent-500 font-medium whitespace-nowrap">{topic.heat}</span>
              <i className="ri-arrow-right-up-line text-xs text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}